import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogService } from '../../../../../../../../../@fuse/components/confirm-dialog/confirm-dialog.service';
import { sentry } from '../../../../../../../../../sentry';
import { ActionTypeEnum } from '../../../../../../../../core/components/fc-tree-view/fc-tree.types';
import { CustomMessagesService } from '../../../../../../../../core/errors/custom-messages.service';
import { fetchAllInBatches } from '../../../../../../../../core/utils/fetch-all-in-batches';
import { DialogEquipmentService } from '../../../../../../../equipments/dialog/dialog-equipments.service';
import { EquipmentsServiceApi } from './equipment.api';
import * as i0 from "@angular/core";
import * as i1 from "./equipment.api";
import * as i2 from "@ngx-translate/core";
import * as i3 from "../../../../../../../equipments/dialog/dialog-equipments.service";
import * as i4 from "../../../../../../../../../@fuse/components/confirm-dialog/confirm-dialog.service";
import * as i5 from "../../../../../../../../core/errors/custom-messages.service";
var EquipmentLinkService = /** @class */ (function () {
    function EquipmentLinkService(equipmentsServiceApi, translateService, dialogEquipmentService, confirmDialogService, messageService) {
        this.equipmentsServiceApi = equipmentsServiceApi;
        this.translateService = translateService;
        this.dialogEquipmentService = dialogEquipmentService;
        this.confirmDialogService = confirmDialogService;
        this.messageService = messageService;
    }
    EquipmentLinkService.prototype.searchEquipments = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, fetchAllInBatches(this.equipmentsServiceApi, params, 500)];
            });
        });
    };
    EquipmentLinkService.prototype.searchEquipmentsWithWarranties = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var pagedResult;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.equipmentsServiceApi.searchWithWarranties(tslib_1.__assign({}, params, { limit: 100 }))];
                    case 1:
                        pagedResult = _a.sent();
                        return [2 /*return*/, pagedResult.items];
                }
            });
        });
    };
    EquipmentLinkService.prototype.formatEquipments = function (equipments, parent) {
        var e_1, _a;
        var formattedEquipments = [];
        if (!equipments) {
            return formattedEquipments;
        }
        try {
            for (var equipments_1 = tslib_1.__values(equipments), equipments_1_1 = equipments_1.next(); !equipments_1_1.done; equipments_1_1 = equipments_1.next()) {
                var equipment = equipments_1_1.value;
                formattedEquipments.push({
                    id: equipment.id,
                    text: equipment.name,
                    parent: parent,
                    description: equipment.number,
                    searchTerm: [equipment.name, equipment.number, equipment.notes].filter(Boolean).join(' ').toLowerCase(),
                    archived: equipment.archived,
                    archivedText: this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.ARCHIVED'),
                    icon: 'equipment',
                    image: equipment.imageUrl,
                    children: [],
                    metadata: 'equipment',
                    action: {
                        type: ActionTypeEnum.menu,
                        buttons: this.equipmentButtons(equipment)
                    }
                });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (equipments_1_1 && !equipments_1_1.done && (_a = equipments_1.return)) _a.call(equipments_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return formattedEquipments;
    };
    EquipmentLinkService.prototype.equipmentButtons = function (equipment) {
        var _this = this;
        var buttons = [
            {
                text: this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.EDIT_EQUIPMENT'),
                icon: 'edit',
                color: '#676767',
                action: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.openEditEquipmentDialog({ equipment: equipment })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }
            },
            {
                text: equipment.archived ? this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.UNARCHIVE_EQUIPMENT') : this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.ARCHIVE_EQUIPMENT'),
                icon: equipment.archived ? 'unarchive_outline' : 'archive_outline',
                color: '#676767',
                action: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.openArchiveOrUnarchiveEquipmentDialog({ equipment: equipment })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }
            }
        ];
        var hasSector = equipment.locationSector;
        var hasEnvironment = equipment.locationEnvironment;
        if (!hasSector && !hasEnvironment) {
            return buttons;
        }
        buttons.push({
            text: hasEnvironment ? this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.UNLINK_EQUIPMENT_ENVIRONMENT') : this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.UNLINK_EQUIPMENT_SECTOR'),
            icon: 'delete',
            color: '#676767',
            action: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.openUnlinkEquipmentDialog({ equipment: equipment })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }
        });
        return buttons;
    };
    EquipmentLinkService.prototype.formatUnlinkedEquipments = function (equipments) {
        if (!equipments.length) {
            return [];
        }
        var treeViewItem = {
            text: this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.EQUIPMENTS_WITHOUT_SECTOR_ENVIRONMENT'),
            icon: 'more_vertical',
            archived: false,
            searchTerm: '',
            archivedText: '',
            action: {
                type: ActionTypeEnum.none,
            }
        };
        treeViewItem.children = this.formatEquipments(equipments, treeViewItem);
        return [treeViewItem];
    };
    EquipmentLinkService.prototype.openCreateEquipmentDialog = function (_a) {
        var location = _a.location;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.dialogEquipmentService.open({
                            equipmentId: null,
                            location: location,
                            disableEditLocation: true
                        })];
                    case 1:
                        result = _b.sent();
                        if (result && result.reload) {
                            window.emitEvent('location-links::reload-tree-view');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    EquipmentLinkService.prototype.openEditEquipmentDialog = function (_a) {
        var equipment = _a.equipment;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.dialogEquipmentService.open({
                            equipmentId: equipment.id,
                            location: null
                        })];
                    case 1:
                        result = _b.sent();
                        if (result && result.reload) {
                            window.emitEvent('location-links::reload-tree-view');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    EquipmentLinkService.prototype.openArchiveOrUnarchiveEquipmentDialog = function (_a) {
        var equipment = _a.equipment;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, err_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.confirmDialogService.open({
                            title: equipment.archived
                                ? this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.UNARCHIVE_EQUIPMENT')
                                : this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.ARCHIVE_EQUIPMENT'),
                            message: equipment.archived
                                ? this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.UNARCHIVE_EQUIPMENT_MESSAGE')
                                : this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.ARCHIVE_EQUIPMENT_MESSAGE'),
                            okText: equipment.archived
                                ? this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.UNARCHIVE')
                                : this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.ARCHIVE'),
                            cancelText: this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.CANCEL')
                        })];
                    case 1:
                        result = _b.sent();
                        if (!result || !result.confirmed) {
                            return [2 /*return*/];
                        }
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 7, , 8]);
                        if (!equipment.archived) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.equipmentsServiceApi.unarchive({
                                id: equipment.id
                            })];
                    case 3:
                        _b.sent();
                        this.messageService.success(this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.UNARCHIVE_EQUIPMENT_SUCCESS', {
                            name: equipment.name
                        }));
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.equipmentsServiceApi.archive({
                            id: equipment.id
                        })];
                    case 5:
                        _b.sent();
                        this.messageService.success(this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.ARCHIVE_EQUIPMENT_SUCCESS', {
                            name: equipment.name
                        }));
                        _b.label = 6;
                    case 6:
                        window.emitEvent('location-links::reload-tree-view');
                        return [3 /*break*/, 8];
                    case 7:
                        err_1 = _b.sent();
                        sentry.captureException(err_1);
                        this.messageService.error(err_1);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    EquipmentLinkService.prototype.openUnlinkEquipmentDialog = function (_a) {
        var equipment = _a.equipment;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, unlinkEnvironmentParam, unlinkSectorParam, err_2;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.confirmDialogService.open({
                            title: equipment.locationEnvironment
                                ? this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.UNLINK_EQUIPMENT_ENVIRONMENT')
                                : this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.UNLINK_EQUIPMENT_SECTOR'),
                            message: equipment.locationEnvironment
                                ? this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.UNLINK_EQUIPMENT_ENVIRONMENT_MESSAGE')
                                : this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.UNLINK_EQUIPMENT_SECTOR_MESSAGE'),
                            okText: this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.UNLINK'),
                            cancelText: this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.CANCEL')
                        })];
                    case 1:
                        result = _b.sent();
                        if (!result || !result.confirmed) {
                            return [2 /*return*/];
                        }
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        unlinkEnvironmentParam = {
                            equipmentId: equipment.id,
                            locationId: equipment.location.id,
                            locationSectorId: equipment.locationSector.id,
                            locationEnvironmentId: null
                        };
                        unlinkSectorParam = {
                            equipmentId: equipment.id,
                            locationId: equipment.location.id,
                            locationSectorId: null,
                            locationEnvironmentId: null
                        };
                        return [4 /*yield*/, this.equipmentsServiceApi.linkEquipment({
                                items: [
                                    equipment.locationEnvironment ? unlinkEnvironmentParam : unlinkSectorParam
                                ]
                            })];
                    case 3:
                        _b.sent();
                        this.messageService.success(this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.UNLINKED_SUCCESS', {
                            name: equipment.name
                        }));
                        window.emitEvent('location-links::reload-tree-view');
                        return [3 /*break*/, 5];
                    case 4:
                        err_2 = _b.sent();
                        sentry.captureException(err_2);
                        this.messageService.error(err_2);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    EquipmentLinkService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EquipmentLinkService_Factory() { return new EquipmentLinkService(i0.ɵɵinject(i1.EquipmentsServiceApi), i0.ɵɵinject(i2.TranslateService), i0.ɵɵinject(i3.DialogEquipmentService), i0.ɵɵinject(i4.ConfirmDialogService), i0.ɵɵinject(i5.CustomMessagesService)); }, token: EquipmentLinkService, providedIn: "root" });
    return EquipmentLinkService;
}());
export { EquipmentLinkService };
